import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setselectedTab } from "../../../Store/B2bslice";
import {
  Button,
  Pagination,
  Spin,
  Select,
  DatePicker,
  Table,
  Tag,
  Tooltip,
} from "antd";
import QrModal from "./QrModal";
import { getUpiReport } from "../../../ApiServices/Apifun";
import { AiOutlineSearch } from "react-icons/ai";
import { formatDateAndTime, trimString } from "../../../Utils";
import { QRCodeCanvas } from "qrcode.react";
import dayjs from "dayjs";
import CommonInput from "../../../Common/CommonInput";

const Upi = () => {
  const dispatch = useDispatch();
  const [openModal, setopenModal] = useState(false);
  useEffect(() => {
    dispatch(setselectedTab("13"));
  }, []);
  const [dataSource, setDataSource] = useState([]);
  const [current, setCurrent] = useState(1);
  const [searchKeyword, setSearchKeyWord] = useState("");
  const [searchcolumn, setSearchColumn] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [totalPages, setTotalPages] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  //   const [openReceiptDrawer, setOpenReceiptDrawer] = useState(false);
  const [qrData, setQrData] = useState(null);
  const [result, setResult] = useState({ data: null, transaction_id: null });
  const [searchOptions, setSearchOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const ReportColumn = [
    {
      title: "Date",
      dataIndex: "Date",
      key: "Date",
      render: (text) => (
        <p className="font-medium w-[150px]">{formatDateAndTime(text)}</p>
      ),
    },
    {
      title: "Transaction Id",
      dataIndex: "transaction_id",
      key: "transaction_id",
      render: (text) => {
        return (
          <>
            <p className=" font-medium  overflow-y-scroll">{text}</p>
          </>
        );
      },
    },
    {
      title: "Payer Mobile",
      dataIndex: "payer_mobile",
      key: "payer_mobile",
      render: (text) => (
        <p style={{ width: "120px" }} className=" font-medium">
          {text?text:"-"}
        </p>
      ),
    },
    {
      title: "Payer Name",
      dataIndex: "payer_name",
      key: "payer_name",
      render: (text) => {
        return (
          <>
            <Tooltip title={text}>
              <p className="font-medium w-[100px] overflow-y-scroll">
                {text ? trimString(text) : "-"}
              </p>
            </Tooltip>
          </>
        );
      },
    },
    {
      title: "QR Code",
      dataIndex: "qr_code",
      key: "qr_code",
      render: (text, record) => {
        return (
          <>
            {record.status === "0" ? (
              <QRCodeCanvas
                onClick={() => {
                  setQrData({
                    link: text,
                    transactionId: record.transaction_id,
                  });
                  setopenModal(true);
                }}
                id="qrCode"
                value={text}
                size={40}
                bgColor={"#ffffff"}
                level={"H"}
              />
            ) : (
              <Tag color="green">Success</Tag>
            )}
          </>
        );
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => {
        return (
          <>
              <p className="font-medium w-[80px] overflow-y-scroll">
                {text ? trimString(text) + " " + "Rs." : "-"}
              </p>
          </>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => {
        return (
          <>
            {text === "1" ? (
              <Tag color="green">Success</Tag>
            ) : 
              <Tag color="yellow">Pending</Tag>
             }
          </>
        );
      },
    },
  ];

  const getReport = (
    search_keyword = searchKeyword,
    search_column = searchcolumn,
    from_date = fromDate,
    to_date = toDate
  ) => {
    setLoading(true);
    const payload = {
      per_page: pageSize,
      page_no: current,
      search_keyword: search_keyword,
      search_column: search_column,
      from_date: from_date,
      to_date: to_date,
    };
    const formdata = new FormData();
    Object.keys(payload).map((key) => formdata.append(key, payload[key]));
    getUpiReport(formdata)
      .then((res) => {
        setDataSource(res.data);
        setTotalPages(res.total);
        setSearchOptions(
          res?.filter_column_name?.map((i, index) => {
            return {
              label: i,
              value: res.filter_column_key[index],
            };
          })
        );
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    getReport();
  }, [current, pageSize]);
  return (
    <>
      <div className="flex justify-end  items-center">
        <Button
          onClick={() => {
            setQrData(null)
            setopenModal(true)
          }}
          className="border-none text-white bg-primary hover:bg-primaryhover"
        >
          Generate Qr
        </Button>
      </div>
      <div className="">
        <div className="prepaid mt-4  animate-fade-in w-full  bg-white shadow-normal  rounded-xl p-4">
          <div className="flex justify-between items-center">
            <p className="font-bold text-[15px] mb-2">UPI Report</p>
            <p
              onClick={() => {
                getReport("", "", "", "");
                setSearchKeyWord("");
                setSearchColumn(null);
                setFromDate("");
                setToDate("");
              }}
              className="font-medium text-xs cursor-pointer bg-bsred hover:bg-red-600 text-white px-2 py-1 rounded-md text-[15px] mb-2"
            >
              Clear Filter
            </p>
          </div>
          <div className="selectionFields grid grid-cols-1 md:grid-cols-3 gap-4 place-items-center ">
            <div className="w-full">
              <p className={`required text-textGray mt-2`}>
                Select Search Type
              </p>
              <Select
                placeholder="Select search type"
                value={searchcolumn}
                onChange={(val) => setSearchColumn(val)}
                className="w-full mt-2"
                options={searchOptions}
              />
            </div>
            <div className="w-full">
              <p className={`required text-textGray `}>Keyword</p>
              {searchcolumn === "upi_collection.created_at" ? (
                <DatePicker
                  // value={dayjs("2023-09-07","YYYY-MM-DD")}
                  popupClassName="bottom-calendar"
                  allowClear
                  // value={searchKeyword}
                  className="w-full datepicker mt-4"
                  onChange={(val) =>
                    setSearchKeyWord(dayjs(val).format("YYYY-MM-DD"))
                  }
                  placement="bottomLeft"
                  placeholder="Search"
                />
              ) : (
                <CommonInput
                  placeholder="Seacrh"
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyWord(e.target.value)}
                  className="outline-none text-xs border mt-4 w-full  border-gray-200 focus:border-primary   px-2 "
                />
              )}
            </div>
            <div className="w-full">
              <p className={`required text-textGray mt-2`}>
                From Date - To Date
              </p>
              <DatePicker.RangePicker
                allowClear
                onChange={(val) => {
                  setFromDate(val ? dayjs(val[0]).format("YYYY-MM-DD") : "");
                  setToDate(val ? dayjs(val[1]).format("YYYY-MM-DD") : "");
                }}
                className="w-full mt-2"
              />
            </div>{" "}
          </div>
          <div className="w-full flex justify-end items-center mt-3">
            <Button
              // disabled=
              onClick={() => getReport()}
              style={{ color: "white" }}
              className=" font-semibold flex justify-between gap-2 items-center hover:bg-primaryhover bg-primary border-none"
            >
              <AiOutlineSearch />
              <p>Search</p>
            </Button>
          </div>
        </div>
      </div>
      <div>
        <div className="mt-4">
          <Spin spinning={loading}>
            <Table
              className="history-table animate-fade-in max-h-[500px]  overflow-x-auto text-white rounded-lg"
              columns={ReportColumn}
              pagination={false}
              onRow={(record, rowIndex) => {
                return {
                  className:"cursor-pointer text-[12px]"
                };
              }}
              dataSource={dataSource}
            />
            <div className="mt-2 mb-8 flex justify-end items-center">
              <Pagination
                defaultPageSize={pageSize}
                showQuickJumper={false}
                defaultCurrent={current}
                current={current}
                onShowSizeChange={(a, b) => setPageSize(b)}
                total={totalPages}
                onChange={(page, pageString) => setCurrent(page)}
              />
            </div>
          </Spin>
        </div>
      </div>
      {/* {openReceiptDrawer && (
        <ReportDrawer
          title={"Receipt"}
          open={openReceiptDrawer}
          setOpen={setOpenReceiptDrawer}
          content={<Content data={result} />}
        />
      )} */}
      {openModal && (
        <QrModal apiCall={getReport} qrData={qrData} openModal={openModal} setopenModal={setopenModal} />
      )}
    </>
  );
};

export default Upi;
